import { Colors } from './../classes/colors';
import { FieldOptions, Icons, ButtonTypes } from '../index';
import { EasyField } from '../baseClasses/easyField';

export class EasyFileUploadField extends EasyField {
    controlType = 'fileupload';
    type: string;
    key: string = '';
    icon: string = '';
    color: string = '';
    hint: string = '';
    allowedExtensions: string = '';

    constructor(options: FieldOptions<any> = {}) {
        super(options);
        this.type = options.type || ButtonTypes.button_icon;
        this.key = options.key || '';
        this.icon = options.icon || Icons.icon_attach_file;
        this.color = options.color || "";
        this.hint = options.hint || '';
        this.allowedExtensions = options.allowedExtensions || '';
        options.controlType = this.controlType;
    }
}